var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-page-base",
    { attrs: { title: "Logs de erro CT-e" } },
    [
      _c(
        "sc-table",
        {
          attrs: {
            loading: _vm.loadingLogList,
            data: _vm.cteLogList,
            total: _vm.cteLogListTotal,
            "per-page": _vm.pagination.size,
            "current-page": _vm.pagination.page,
            paginated: true,
            "backend-pagination": true
          },
          on: {
            "page-change": function(newPage) {
              return (_vm.pagination.page = newPage)
            }
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(ref) {
                var row = ref.row
                return [
                  _c(
                    "sc-table-column",
                    { attrs: { label: "Nome do arquivo", field: "filename" } },
                    [_vm._v("\n        " + _vm._s(row.filename) + "\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    { attrs: { label: "CT-e", field: "cte_identifier" } },
                    [
                      _vm._v(
                        "\n        " + _vm._s(row.cte_identifier) + "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        label: "Transportadora",
                        field: "logistic_provider_id"
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.getLogisticProviderName(
                              row.logistic_provider_id
                            )
                          ) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        label: "Data de processamento",
                        field: "processing_date_time"
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("date")(
                              row.processing_date_time,
                              "DD/MM/YYYY"
                            )
                          ) +
                          " às\n        " +
                          _vm._s(
                            _vm._f("date")(row.processing_date_time, "HH:mm")
                          ) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: { label: "Forma de envio", field: "file_source" }
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(row.file_source) + "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        label: "Motivo do erro",
                        field: "processing_description"
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(row.processing_description) +
                          "\n      "
                      )
                    ]
                  )
                ]
              }
            }
          ])
        },
        [
          _c("template", { attrs: { slot: "footer" }, slot: "footer" }, [
            _vm.cteLogListTotal
              ? _c("p", [
                  _c("strong", [_vm._v("Total de registros:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.cteLogListTotal))])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "template",
            { attrs: { slot: "bottom-left" }, slot: "bottom-left" },
            [
              _c("sc-table-per-page", {
                model: {
                  value: _vm.pagination.size,
                  callback: function($$v) {
                    _vm.$set(_vm.pagination, "size", $$v)
                  },
                  expression: "pagination.size"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "template",
            { attrs: { slot: "empty" }, slot: "empty" },
            [_c("sc-table-empty")],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-94438138", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94438138","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/cte-logs/PageCTeLogs.vue
// module id = null
// module chunks = 